define('Components/ProductListWidget/js/views/CheckoutCTAWidgetInstanceView',['jquery','WidgetInstanceView','app',
        'BtnSwitchView',
        'template!Components/ProductListWidget/templates/checkout-CTA'
    ],
    function($, WidgetInstanceView, app,
             BtnSwitchView,
             checkoutCTATemplate
    ){
        //
        // Cette View et le template a été initialement créé
        // lors du lancement de la Carte 2018
        // afin d'afficher une bannière pour ajouter la carte dans le panier (c'est un produit gratuit)
        //
        return WidgetInstanceView.extend({
            name:'ProductListWidgetInstanceView',
            activeSlide: 0,
            events: {
                'click button':'buttonSwitch'
            },
            setup:function(){
                var view = this;
                view.preRender();
                view.render();
                view.listenTo(app.getCart(),'changeContext',view.onChangeContext);
            },
            onChangeContext:function(){
                var view = this;
                view.preRender();
                view.render();
                view.afterRender();
            },
            getProduct:function(){
                var bannerProduct = this.model.getProduct();
                return bannerProduct;
            },
            afterRender:function() {
                var view = this,
                    bannerProduct = view.getProduct();
                if(!bannerProduct) return;
                var isProductInCart = bannerProduct && (app.getCart().getProductsById(bannerProduct.id).size() > 0),
                    btnSwitchEl = view.$('.btn-switch').get(0),
                    btnSwitch;
                // gère le switch
                btnSwitch = new BtnSwitchView({value:isProductInCart?'yes':'no',el:btnSwitchEl});
                view.attachView(btnSwitch);
                view.listenTo(btnSwitch,'change',view.onSwitchChange);
            },
            onSwitchChange:function(value){
                var bannerProduct = this.getProduct(),
                    bannerProductId = bannerProduct ? bannerProduct.id :false,
                    cart = app.getCart();
                //
                if(bannerProductId){
                    switch(value){
                        case 'yes': // ajoute le produit au panier
                            cart.addProduct(bannerProductId);
                            break;
                        case 'no': default: // retire le produit du panier
                            cart.deleteProduct(bannerProductId);
                            break;
                    }
                }
            },
            getTemplate:function(){
                return checkoutCTATemplate;
            },

        })
    });
